module.exports = __webpack_public_path__ + "img/lunar-module.446b52fb.svg";